import { Color } from "./types";

export const COLOR_MAP: Record<Color, string> = {
  ORANGE: "orange",
  RED: "#F22B29",
  WHITE: "white",
  BLUE: "#0080FF",
};
